/* eslint-disable */
import React, {useState} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FeatherIcon from 'feather-icons-react';
import { useEffect } from 'react';
import ButtonV2 from 'components/ButtonV2';
import * as fileSaver from 'file-saver';
import { Alert,AlertType } from "utils/Alert";
import moment from "moment";
import styled from "styled-components";
import downloadIcon from "_assets/icons/download.svg";
// services
import channelUsageSvc from 'services/channelUsageSvc';
import GraphicMultiLine from "./GraphicMultiLine";

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const LoadingPage = () => {
  const _renderLoading = () => {
    const loadingTemplate = [];
    for (let i = 0; i < 7; i += 1) {
      loadingTemplate.push(
        <div className="spinner-grow text-dark" style={{ margin: "10px" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      );
    }
    return loadingTemplate;
  };

  return <LoadingContainer>{_renderLoading()}</LoadingContainer>;
};

function WhatsappSession(props) {
  const {channel, startDate, endDate, applicationId} = props;
  const [isDataDetail, setDataDetail]= useState([])
  const [isLoadingDownload, setLoadingDownload]= useState(false);
  const [isLoadingGetSession, setLoadingGetSession]= useState(false);
  const [isDataWhatsapp, setDatWhatsapp]= useState([
    {
      name: 'Total',
      name2: 'Conversation',
      total_transaction: 12003,
      tooltip: `The number of messages that have been sent but on the customer's side still hasn't arrived`
    },
    {
      name: 'Business',
      name2: 'Initiated',
      total_transaction: 12003,
      tooltip: `The number of messages that have arrived but have not been read by the customer or read receipts on the customer side are deactivated (two gray ticks).`
    },
    {
      name: 'Customer',
      name2: 'Initiate',
      total_transaction: 12003,
      tooltip: 'The number of messages that have been read on the customer side'
    },
    {
      name: 'WA',
      name2: 'Marketing',
      total_transaction: 12003,
      tooltip: 'tooltip'
    },
    {
      name: 'WA',
      name2: 'Utility',
      total_transaction: 12003,
      tooltip: 'tooltip'
    },
    {
      name: 'WA',
      name2: 'Authentication',
      total_transaction: 12003,
      tooltip: 'tooltip'
    },
  ])
  const [report, setReport] = useState([]);
  const [isStatusDate, setStatusDate] = useState(null);

  useEffect(()=> {
    if(channel){
      switch (channel) {
        case 'whatsapp':
          getWhatsappSession();
          // geChartWhatsapp();
          break;
      
        default:
          break;
      }
    }
  }, [])

  const getGrapichData = (reportData) => {
    const labels = [];
    const datasets = [{
      label: 'Total Conversation',
      fill: true,
      lineTension: 0,
      borderColor: '#1D67CB',
      borderWidth: 2,
      data: []
    }, 
    {
      label: 'Business Initiated',
      fill: true,
      lineTension: 0,
      borderColor: '#FF8B00',
      borderWidth: 2,
      data: []
    },
    {
      label: 'Customer Initiate',
      fill: true,
      lineTension: 0,
      borderColor: '#219653',
      borderWidth: 2,
      data: []
    },
    {
      label: 'WA Marketing',
      fill: true,
      lineTension: 0,
      borderColor: '#42526E',
      borderWidth: 2,
      data: []
    },
    {
      label: 'WA Utility',
      fill: true,
      lineTension: 0,
      borderColor: '#42526E',
      borderWidth: 2,
      data: []
    },
    {
      label: 'WA Authentication',
      fill: true,
      lineTension: 0,
      borderColor: '#42526E',
      borderWidth: 2,
      data: []
    }];

    if(reportData.length < 1) return;
    reportData.forEach((val) => {
       if(startDate === endDate){
          labels.push(moment.utc(val.date || val.created_at).local().add("hour").format('hh:mm A'));
          setStatusDate(true)
       }else{
          setStatusDate(false)
         labels.push(moment(val.date || val.created_at).add("day").format("DD MMM"));
       }
      datasets[0].data.push(val.total_conversation);
      datasets[1].data.push(val.total_bussiness_initiated);
      datasets[2].data.push(val.total_customer_initiated);
      datasets[3].data.push(val.total_marketing);
      datasets[4].data.push(val.total_utility);
      datasets[5].data.push(val.total_authentication);
      return true;
    });

    return {
      labels,
      datasets
    }
  }

  // INTEGRATION
  function convertStatus(item){
    switch (item) {
      case 'Total' || 'Conversation':
          return 'read'
        break;
      case 'Business' || 'Initiated':
          return 'submitted'
        break;
      case 'Customer' || 'Initiate':
          return 'delivered'
        break;
      case 'WA' || 'Marketing':
          return 'cl-neutral400'
        break;
      case 'WA' || 'Utility':
          return 'cl-neutral400'
        break;
      case 'WA' || 'Authentication':
          return 'cl-neutral400'
        break;

      default:
        break;
    }
  }

  const getWhatsappSession = async () => {
    setLoadingGetSession(true);
    const appId = applicationId
    const reqBody = {
      startDate: startDate,
      endDate: endDate,
      // application_id: '65e82872d797b500121d1e91'
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosSessionWhatsapp(reqBody, appId)
      console.log('result wa', result)
      if(result.data.data){
        for (let index = 0; index < isDataWhatsapp.length; index++) {
          if(result.data.data.total_all_conversation !== null && isDataWhatsapp[index].name2 === 'Conversation'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_conversation
          }
          if(result.data.data.total_all_bussiness_initiated !== null && isDataWhatsapp[index].name2 === 'Initiated'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_bussiness_initiated
          }
          if(result.data.data.total_all_customer_initiated !== null && isDataWhatsapp[index].name2 === 'Initiate'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_customer_initiated
          }
          if(result.data.data.total_all_marketing !== null && isDataWhatsapp[index].name2 === 'Marketing'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_marketing
          }
          if(result.data.data.total_all_utility !== null && isDataWhatsapp[index].name2 === 'Utility'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_utility
          }
          if(result.data.data.total_all_authentication !== null && isDataWhatsapp[index].name2 === 'Authentication'){
            isDataWhatsapp[index].total_transaction = result.data.data.total_all_authentication
          }
        }
        setDataDetail(isDataWhatsapp)

        setReport(getGrapichData(result.data.data.total));
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {setLoadingGetSession(false)}
  }

  const geChartWhatsapp = async () => {
    const appId = applicationId
    const reqBody = {
      startDate: startDate,
      endDate: endDate,
      application_id: applicationId
    }
    try {
      let result = await channelUsageSvc.axiosChartSessionWhatsapp(reqBody, appId)
      if(result.data){
        result.data.forEach((val) => {
          val.resultSucces = val.total_delivered + val.total_read;
          val.resultFailed = val.total_failed + val.total_rejected + val.total_submitted;
        })
        setReport(getGrapichData(result.data));
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Something went wrong or Data Is Empty'
      )
    } finally {}
  }

  const downloadWaSession = async () => {
    const appId = applicationId
    const reqParams = {
      start_date: startDate,
      end_date: endDate,
      application: applicationId,
    }
    try {
      let result = await channelUsageSvc.axiosDownloadSessionWhatsapp(reqParams, appId)
     
      if(result?.data){
        let filename = `Report_Session_WA_${startDate}-${endDate}`;
        let accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        let blob = new Blob([result.data], { type: accept });
        fileSaver.saveAs(blob, filename);
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Report results have been downloaded successfully'
        )
      }else{
        if(!result.data) {
          Alert.showStatus(
            AlertType.ERROR,
            'Error!',
            error.message || error
          )
        }
      }
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message || error
      )
    } finally {setLoadingDownload(false) }
  }
  // END INTEGRATION

  return (
    <div>
      <div className="wrapper_detail_transaction">
        <div className='d-flex align-items-center justify-content-between border-bottom w-100 mb-4 pb-3'>
          <div className='cl-deep-black fweight-600 fsize-16'>Whatsapp Session</div>
          <ButtonV2 
            disabled={isLoadingDownload || isLoadingGetSession}
            loadingCreate={isLoadingDownload}
            className='ms-2 d-flex align-items-center'
            handleRoute={()=>downloadWaSession()} 
            backgroundColor="#3B3B47"
            textColor="#FFFFFF"
            padding=".360rem 1rem"
          >
            <img
              src={downloadIcon}
              className="me-2"
              alt="downloadIcon" 
            />
            Export to Excel
          </ButtonV2>
        </div>
        <div className="d-flex align-items-center justify-content-between w-100 pb-3">
          {!isLoadingGetSession && isDataDetail && isDataDetail.map((item, index) => {
          return (
            <div key={index} className={`box d-flex flex-column align-items-center ${isDataDetail.length - 1 !== index && 'border-end'}`}>
              <div className='text-center'>
                <div className="d-flex align-items-start mb-2">
                  <h3 
                    className={` ${convertStatus(item.name)} text-center fweight-500 fsize-14 m-0`}
                    >
                      {item.name} <br></br>
                      {item.name2}
                    </h3>
                  {/* <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="button-tooltip-2">{item.tooltip}</Tooltip>}
                    >
                      <span className='ic_info d-flex align-items-center ms-2'>
                        <FeatherIcon className="cl-light-grey pinkic-hover" icon="info" />
                      </span>
                  </OverlayTrigger> */}
                </div>
                <div className="cl-neutral500 fweight-600 fsize-16">{item.total_transaction}</div>
              </div>
            </div>
            )
          })}
        </div>
      </div>
      {!isLoadingGetSession && (
        <div className="margin-top-30" >
          <GraphicMultiLine grapichData={report} isStatusDate={isStatusDate}/>
        </div>
      )}

      {isLoadingGetSession && (
        <LoadingPage />
      )}
    </div>
  )
}

export default WhatsappSession